var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-md p-3 lg:p-6 lg:text-2xl border",class:_vm.isSelected ? 'border-luxcaddy-600 bg-luxcaddy text-white' : 'border-gray-200 bg-gray-100',on:{"click":_vm.setAsSelected}},[_vm._v(" "+_vm._s(_vm.year)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }